import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWallet } from "../lib/wallet";
import { fetchWalletTokens } from "../lib/api";
import TokenCard from "../components/TokenCard";

export default function MyTokensPage() {
    const { t } = useTranslation();
    const { account, connect } = useWallet();
    const [tokens, setTokens] = useState([]);

    useEffect(() => {
        if (account) fetchWalletTokens(account).then(setTokens);
    }, [account]);

    return (
        <div data-testid="my-tokens-page" className="max-w-7xl mx-auto px-4 md:px-8 py-12">
            <div className="text-xs uppercase tracking-[0.3em] text-frost mb-3">{t("my.kicker")}</div>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight">
                {t("my.title_1")} <span className="italic">{t("my.title_2")}</span>
            </h1>

            {!account ? (
                <div className="mt-16 text-center border border-white/10 p-16">
                    <p className="text-slate-400 mb-6">{t("my.connect_text")}</p>
                    <button
                        data-testid="my-tokens-connect"
                        onClick={connect}
                        className="btn-sharp bg-white text-obsidian px-6 py-3 text-xs hover:bg-slate-200"
                    >
                        {t("my.connect_btn")}
                    </button>
                </div>
            ) : tokens.length === 0 ? (
                <div className="mt-16 text-center border border-white/10 p-16 text-slate-400">
                    {t("my.empty")}
                </div>
            ) : (
                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {tokens.map((tk) => <TokenCard key={tk.number} token={tk} />)}
                </div>
            )}
        </div>
    );
}
